import {ConfigObjectType, StateId} from '@wallaby-ui/core';
import classNames from 'classnames';
import * as React from 'react';
import {Collapse} from 'react-bootstrap';

import styles from './FilterNode.less';
import FilterNodeContainer from './FilterNodeContainer';
import FilterNodeContent from './FilterNodeContent';
import FilterNodeTick from './FilterNodeTick';
import {Filter} from 'src/js/lib/filtering';
import {
  FilterSchema,
  FilterNode as FilterNodeModel,
} from 'src/js/model/filters_config';

interface OwnProps {
  areChildrenClickable?: boolean;
  autocomplete: (input: any) => void;
  autocompleteSetValues?: (values: any) => void;
  changeFilter: (values: any) => void;
  config: ConfigObjectType;
  filteringStateId: StateId;
  filterAndSearchStateId: StateId;
  isClickable?: boolean;
  isFilterSelected: (filter: Filter) => void;
  isOpened?: boolean;
  level?: number;
  node: FilterNodeModel;
  parentName?: string;
  removeFilter: (filter: Filter) => void;
  schema: FilterSchema;
  searchServiceUrl: string;
  selectedAutocompleteValues?: any[];
  selectedFilter?: Filter;
  toggleOpened: () => void;
  filterFocused: any;
}

type Props = OwnProps;

export const FilterNode: React.FC<Props> = (props) => {
  const {
    areChildrenClickable = false,
    config,
    filterAndSearchStateId,
    filteringStateId,
    isOpened = false,
    level = 0,
    node,
    parentName,
    schema,
    searchServiceUrl,
    autocomplete,
    autocompleteSetValues,
    changeFilter,
    isClickable = false,
    isFilterSelected,
    removeFilter,
    selectedAutocompleteValues,
    selectedFilter,
    toggleOpened,
    filterFocused,
  } = props;

  const renderChildren = () => {
    return (
      <ul
        className={classNames(
          styles.dlFilterNodeChildren,
          styles.dlIndentedList
        )}
      >
        {node.getChildrenIds().map((filterId) =>
          schema.getFilter(filterId).getType() ? (
            // <Collapse in={isOpened} key={filterId}>
            <div>
              <FilterNodeContainer
                config={config}
                searchServiceUrl={searchServiceUrl}
                filterAndSearchStateId={filterAndSearchStateId}
                filteringStateId={filteringStateId}
                node={schema.getFilter(filterId)}
                level={level + 1}
                schema={schema}
                isClickable={areChildrenClickable}
                parentName={parentName}
              />
            </div>
          ) : // </Collapse>
          null
        )}
      </ul>
    );
  };

  return (
    <div
      className={styles.dlFilterNode}
      style={node.getIndent() ? {paddingLeft: `${node.getIndent()}px`} : {}}
      data-name={node.getName()}
    >
      <li role='treeitem'>
        <div className={styles.dlFilterNodeItem}>
          {
            // render tick only if it is artificial node without type
            node.getType() ? null : (
              <FilterNodeTick isOpened={isOpened} toggleOpened={toggleOpened} />
            )
          }
          <FilterNodeContent
            areChildrenClickable={areChildrenClickable}
            autocomplete={autocomplete}
            autocompleteSetValues={autocompleteSetValues}
            config={config}
            filterFocused={filterFocused}
            isOpened={isOpened}
            toggleOpened={toggleOpened}
            node={node}
            changeFilter={changeFilter}
            removeFilter={removeFilter}
            parentName={parentName}
            isClickable={isClickable}
            isFilterSelected={isFilterSelected}
            selectedFilter={selectedFilter}
            selectedAutocompleteValues={selectedAutocompleteValues}
            schema={schema}
          />
        </div>
      </li>
      {renderChildren()}
    </div>
  );
};

FilterNode.displayName = 'FilterNode';

export default FilterNode;
